import React from "react";
import './SeparatorPrototype.scss';
import { useTranslation } from 'react-i18next';

const SeparatorPrototype = () => {
  const { t } = useTranslation();

  return (
    <>
      <div id="prototipos" className="contenedor-prototipo">
        <div className="contenedor-prototipo-principal">
          <h2>{t('separatorPrototype.title')}</h2>
          <p>{t('separatorPrototype.subtitle')}</p>
          <div className="contenedor-textos">
            <p>{t('separatorPrototype.text1')}</p>
            <p>{t('separatorPrototype.text2')}</p>
          </div>
          <div className="contenedor-textos">
            <p>{t('separatorPrototype.text3')}</p>
            <p>{t('separatorPrototype.text4')}</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default SeparatorPrototype;
